import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import Autocomplete from '../../../../Shared/AutoCompleteInput/AutoCompleteInput.js';
import TextInput from '../../../../Shared/TextInput/TextInput';
import { setIsSubmit } from '../../energySaleBlockSlice';
import { showAppLoader, hideAppLoader } from '../../../../Shared/Loader/LoaderSlice';
import ProviderManager from '../../../../../provider/providerManager';

const AddressForm = (props) => {
  const [cities, setCities] = useState([]);
  const [streets, setStreets] = useState([]);
  const [address, setAddress] = useState({
    city: { value: '', code: '', semel: '', error: '' },
    street: { value:'', code: '', semel: '', gisSemel: '', error: '' },
    home: { value: '', error: '' },
    apartment: { value: '', error: '' },
  });
  const [isCityWithoutStreets, setIsCityWithoutStreets] = useState({ value: false });
  const [currentFocus, setCurrentFocus] = useState({ value: '' });
  const cityRef = useRef();
  const streetRef = useRef();
  const homeRef = useRef();
  const apartmentRef = useRef();
  const [form, setForm] = useState({ cityName: props.selectedAddress?.cityName ?? '', streetName: props.selectedAddress?.streetName ?? '' });

  useEffect(() => {
    (async function getCities() {
      props.showAppLoader();
      try {
        const result = await ProviderManager.getProviderData('getCities', []);
        if (result.errorCode == undefined) {
          setCities(result.Body);
        }
      } catch (error) { }
      finally {
        props.hideAppLoader();
      }
    })();
    return () => { };
  }, []);

  async function citySelectedChange(cityCode) {
    const selectedCity = cities.find((x) => x.cityCode === cityCode);
    if (selectedCity) {
      address.city = { value: selectedCity.cityName, code: cityCode, semel: selectedCity.citySemel, error: '' };
      address.street = { value: '', code: '', semel: '', gisSemel: '', error: '' };
      address.home = { value: '', error: '' };
      address.apartment = { value: '', error: '' };
      form.cityName = '';
      form.streetName = '';
      setAddress({ ...address });
      setForm({ ...form });

      streetRef?.current?.onChange({ currentTarget: { value: '' } });
      getStreets(selectedCity.cityCode, selectedCity.cityName);
    } else {
      address.city = { value: '', code: '', semel: '', error: 'יש לבחור יישוב' };
      setAddress({ ...address });
    }
  }

  async function getStreets(cityCode, cityName) {
    const result = await ProviderManager.getProviderData('getStreetsByCity', [cityCode]);
    const streets = result.Body;
    setStreets(streets);


    if (streets.length == 0) {
      setIsCityWithoutStreets({ ...isCityWithoutStreets, value: true });
      address.street = { value: cityName, code: '9000', semel: '9000', error: '' };
      address.home = { value: '1', error: '' };
      address.apartment = { value: '1', error: '' };
      setAddress({ ...address });
    } else {
      setIsCityWithoutStreets({ ...isCityWithoutStreets, value: false });
      if (!props.selectedAddress || Object.keys(props.selectedAddress).length === 0) {
        setAddress({ ...address, street: { value: '', code: '', semel: '', error: '' } });
      }
      setCurrentFocus({ ...currentFocus, value: 'street' });
    }
  }

  async function streetSelectedChange(streetCode) {
    const selectedStreet = streets.find((x) => x.streetCode === streetCode);

    if (selectedStreet) {
      address.street = { value: selectedStreet.streetName, code: selectedStreet.streetCode, semel: selectedStreet.streetSemel, gisSemel: selectedStreet.streetGisSemel, error: '' };
      setCurrentFocus({ ...currentFocus, value: 'home' });
    } else {
      address.street = { value: '', code: '', semel: '', error: 'יש לבחור רחוב' }
    }

    if (!props.selectedAddress || Object.keys(props.selectedAddress).length === 0) {
      address.home = { value: '', error: '' };
      address.apartment = { value: '', error: '' };
    }

    setAddress({ ...address });

  }

  function homeChange(home) {
    if (home) {
      setAddress({ ...address, home: { value: home, error: '' } });
    } else {
      setAddress({ ...address, home: { value: home, error: 'יש להזין מספר בית' } });
    }
  }

  function apartmentChange(apartment) {
    if (apartment) {
      setAddress({ ...address, apartment: { value: apartment, error: '' } });
    } else {
      setAddress({ ...address, apartment: { value: apartment, error: 'יש להזין מספר דירה' } });
    }
  }

  function handleKeyDown(e, field) {
    if (e.key === 'Enter') {
      switch (field) {
        case 'home':
          setCurrentFocus({ ...currentFocus, value: 'floor' });
          break;
        case 'apartment':
          submit();
          break;
      }
    }
  }

  useEffect(() => {
    switch (currentFocus.value) {
      case 'street':
        if (streetRef.current) streetRef.current?.autoCompleteRef?.current?.focus();
        break;
      case 'home':
        if (homeRef.current) homeRef.current.focus();
        break;
      case 'apartment':
        if (apartmentRef.current) apartmentRef.current.focus();
        break;
    }
  }, [currentFocus]);

  useEffect(() => {
    if (props.isSubmit) {
      submit();
    }
  }, [props.isSubmit]);

  const checkIsValid = () => {
    let isValid = true;
    if (!address.city.value) {
      isValid = false;
      address.city.error = 'יש לבחור יישוב';
      setAddress({ ...address });
    }
    if (!address.street.value) {
      isValid = false;
      address.street.error = 'יש לבחור רחוב';
      setAddress({ ...address });
    }
    if (address.home.value == '') {
      isValid = false;
      address.home.error = 'יש לבחור מספר בית';
      setAddress({ ...address });
    }
    if (address.apartment.value == '' || address.apartment.value < 0) {
      isValid = false;
      address.apartment.error = 'יש להזין מספר דירה';
      setAddress({ ...address });
    }
    if (address.apartment.value == '0' ) {
      isValid = false;
      address.apartment.error = 'יש להזין מספר דירה תקין';
      setAddress({ ...address });
    }
    return isValid;
  };

  async function submit() {
    props.showAppLoader();
    const isValid = checkIsValid();
    if (isValid) {
      if (address.street.semel)
        await getZipCode();
    }
    const response = setResponse(isValid);
    props.hideAppLoader();
    props.onSubmit(response);
  }

  async function getZipCode() {
    const zipCodeResult = await ProviderManager.getProviderData('getZipCode', [
      address.street.code,
      address.city.code,
      address.home.value,
      'no_entrance'
    ]);
    address.zipCode = { value: zipCodeResult.Body };
    setAddress({ ...address });
  }

  const setResponse = (isValid) => {
    let addressInfo = {};

    addressInfo.cityCode = address.city.code;
    addressInfo.citySemel = address.city.semel;
    addressInfo.cityName = address.city.value;
    addressInfo.streetCode = address.street.code;
    addressInfo.streetSemel = address.street.semel;
    addressInfo.streetGisSemel = address.street.gisSemel;
    addressInfo.streetName = address.street.value;
    addressInfo.home = address.home.value;
    addressInfo.apartment = address.apartment.value;
    addressInfo.zipCode = address.zipCode?.value;
    return { selectedAddress: addressInfo, isValid: isValid };
  };

  return (
        <div className='energy-sale-address-wrapper'>
          <h2>הכתובת אליה משוייך חשבון החשמל</h2>
          <div className='form-wrapper'>
            <div className='row-wrapper'>
              <Autocomplete
                ref={cityRef}
                injectedValue={props.selectedAddress?.cityName ?? ''}
                form={form}
                autofocus={true}
                error={address.city.error}
                value={address.city.value}
                id='city'
                name='city'
                onSelectedChange={(e) => citySelectedChange(e.target.value)}
                suggestions={cities}
                dataKey='cityCode'
                dataValue='cityName'
                placeholder='שם יישוב'
                required='required'
              />
            </div>

            <div className='row-wrapper'>
              {isCityWithoutStreets.value ? (
                <TextInput
                  value={address.street.value}
                  placeholder='רחוב'
                  id='dummyStreet'
                  name='dummyStreet'
                  type='text'
                  disabled={'disabled'}
                  maxLength='10'
                  autoComplete='off'
                  required='required'
                />
              ) : (
                <Autocomplete
                  ref={streetRef}
                  injectedValue={address.street.value ?? ''}
                  form={form}
                  error={address.street.error}
                  value={address.street.value}
                  id='street'
                  name='street'
                  disabled={address.city.value != '' ? '' : 'disabled'}
                  onSelectedChange={(e) => streetSelectedChange(e.target.value)}
                  suggestions={streets}
                  dataKey='streetCode'
                  dataValue='streetName'
                  placeholder='רחוב'
                  required='required'
                />
              )}
            </div>
            <div className='row-wrapper multiple-fields'>
              <div>
                <TextInput
                  ref={homeRef}
                  value={address.home.value}
                  error={address.home.error}
                  placeholder='מספר בית'
                  id='home'
                  name='home'
                  maxLength='4'
                  disabled={!isCityWithoutStreets.value && address.street?.value != '' ? '' : 'disabled'}
                  type='number'
                  pattern='[0-9]*'
                  autoComplete='off'
                  onChange={(e) => homeChange(e.target.value)}
                  required='required'
                  onKeyDown={(e) => handleKeyDown(e, 'home')}
                />
              </div>
              <div>
                <TextInput
                  ref={apartmentRef}
                  value={address.apartment.value}
                  error={address.apartment.error}
                  placeholder='דירה'
                  id='apartment'
                  name='apartment'
                  maxLength='4'
                  disabled={!isCityWithoutStreets.value && address.street?.value != '' ? '' : 'disabled'}
                  type='number'
                  pattern='[0-9]*'
                  autoComplete='off'
                  onChange={(e) => apartmentChange(e.target.value)}
                  required='required'
                  onKeyDown={(e) => handleKeyDown(e, 'apartment')}
                />
                <div className='apartment-message'>*אם זה בית פרטי הקלידו מספר דירה 1</div>
              </div>
              </div>
            </div>
          </div>
  );
};

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = {
  setIsSubmit,
  showAppLoader,
  hideAppLoader,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddressForm);
